import styled from "styled-components";

import color from "constants/color";
import font from "constants/font";

const Wrap = styled.div`
  position: relative;
  height: content-fit;
  display: flex;
  align-items: center;
`;
export const CheckBoxLabel = styled.label<{
  checked: boolean;
  disabled: boolean;
  eventNone: boolean;
  editable: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ disabled }) => (disabled ? color.form.disabledBackground : color.text.black)};
  cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
  ${({ eventNone }) => (eventNone ? "pointer-events: none;" : "")};
  position: relative;

  &::before {
    content: "";
    display: inline-block;
    width: 22px;
    height: 22px;
    border-radius: 3px;
    border: solid 1px
      ${({ disabled, checked }) =>
        disabled ? color.form.disabledBackground : checked ? color.text.link : color.form.border};
    background-color: ${({ disabled, checked, editable }) =>
      disabled ? color.form.disabledBackground : editable ? checked && color.text.link : color.text.blue};
    position: relative;
    flex-shrink: 0;
  }

  // チェックマーク（中に擬似要素として追加）
  &::after {
    content: "";
    position: absolute;
    top: 5px;
    left: 9px;
    width: 5px;
    height: 10px;
    border-right: 2px solid
      ${({ disabled, checked, editable }) =>
        disabled ? color.form.disabledBackground : checked ? (!editable ? "white" : color.white) : "transparent"};
    border-bottom: 2px solid
      ${({ disabled, checked, editable }) =>
        disabled ? color.form.disabledBackground : checked ? (!editable ? "white" : color.white) : "transparent"};
    transform: rotate(45deg);
    pointer-events: none;
  }

  ${({ checked, disabled, editable }) => `
    ${
      editable &&
      `&:hover::before {
    border: solid 1px
      ${disabled ? color.form.disabledBackground : checked ? color.text.linkDark : color.text.black};
    background-color: ${
      disabled ? color.form.disabledBackground : checked ? color.text.linkDark : color.form.background
    };
  }`
    }
  `}
`;

export const CheckBoxHiddenInput = styled.input.attrs({ type: "checkbox" })`
  display: none;
`;

const Span = styled.span<{ fontSize: string }>`
  font-size: ${(props) => props.fontSize};
`;

const CheckBox = ({
  id,
  checked,
  onCheck,
  label,
  disabled = false,
  eventNone = false,
  fontSize = font.size16,
  editable = true,
}: {
  id: string;
  checked: boolean;
  onCheck: () => void;
  label?: string;
  disabled?: boolean;
  eventNone?: boolean;
  fontSize?: string;
  editable?: boolean;
}) => {
  return (
    <Wrap>
      <CheckBoxHiddenInput
        id={id}
        checked={checked}
        onChange={editable ? onCheck : undefined}
        disabled={disabled || !editable}
      />
      <CheckBoxLabel htmlFor={id} checked={checked} disabled={disabled} eventNone={eventNone} editable={editable}>
        <Span fontSize={fontSize}>{label}</Span>
      </CheckBoxLabel>
    </Wrap>
  );
};

export default CheckBox;
